import { render, staticRenderFns } from "./list-message.vue?vue&type=template&id=ef9895f6&"
import script from "./list-message.vue?vue&type=script&lang=js&"
export * from "./list-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports